import { VOICE_CALL } from '../../constants/voice-call-constants';

const { DAILY, WEEKLY } = VOICE_CALL.MINUTE_CAP_PERIOD;

/** @param {string | null | undefined} period */
export const isWeeklyCap = (period) => (period || DAILY).toUpperCase() === WEEKLY;

export function resolveCapWindowFields(period, response) {
  const {
    maxCallDurationPerDay: maxPerDayLegacy,
    consumedCallDurationPerDay: consumedPerDayLegacy,
    remainingCallDurationPerDay: remainingPerDayLegacy,
    maxCallDurationPerCapPeriod,
    consumedCallDurationPerCapPeriod,
    remainingCallDurationPerCapPeriod,
  } = response;
  const weekly = isWeeklyCap(period);
  const maxCallDurationPerDayOrPeriod = weekly
    ? (maxCallDurationPerCapPeriod ?? maxPerDayLegacy)
    : maxPerDayLegacy;
  const consumedRaw = weekly
    ? (consumedCallDurationPerCapPeriod ?? consumedPerDayLegacy)
    : consumedPerDayLegacy;
  const remainingRaw = weekly
    ? (remainingCallDurationPerCapPeriod ?? remainingPerDayLegacy)
    : remainingPerDayLegacy;
  return { maxCallDurationPerDayOrPeriod, consumedRaw, remainingRaw };
}

export function isCompleteUsageResponse(maxCallDurationPerCall, maxCap, consumedRaw, remainingRaw) {
  return (
    maxCallDurationPerCall !== null &&
    maxCallDurationPerCall !== undefined &&
    maxCap !== null &&
    maxCap !== undefined &&
    consumedRaw !== null &&
    consumedRaw !== undefined &&
    remainingRaw !== null &&
    remainingRaw !== undefined
  );
}

export function converTimeIntoMintuesAndSeconds(duration) {
  const minutes = Math.floor(duration);
  const seconds = Math.round((duration - minutes) * 60);
  const totalMinutes = seconds >= 1 && seconds <= 59 ? minutes + 1 : minutes;
  return totalMinutes === 1 ? `${totalMinutes} minute` : `${totalMinutes} minutes`;
}
